import React, { useEffect, useState } from 'react';
import { getUser } from './Functions';

function Auth({ children }) {
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const datosAcceso = localStorage.getItem('datosAcceso');
        if (datosAcceso) {
          const { email } = JSON.parse(datosAcceso);
          const userData = await getUser(email);
          if (userData) {
            setNombreUsuario(userData.name);
            setIsAdmin(userData.admin === 1);
          }
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error al obtener los datos del usuario:', error);
        setIsLoading(false); 
      }
    }
    fetchData();
  }, []);

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  if (!nombreUsuario) {
    window.location.href = '/login';
    return null;
  }

  const handleLogout = () => {
    localStorage.removeItem('datosAcceso');
    window.location.href = '/login';
  };

  return children({ nombreUsuario, isAdmin, handleLogout });
}

export default Auth;
